<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      unit="存货分类"
      edit-title
      id-key="ClassId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="() => {}"
      @opened="onOpened"   
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="上级分类">
          <el-select  v-model="data.Pid" clearable @change="changePid">
            <el-option v-for="item in classList " :key="item.ClassId" :value="item.ClassId" :label="item.ClassName"></el-option>
          </el-select>
          <!-- <span v-if="Mode==0" class="detail-span">{{data.DpNo}}</span>
           <el-input v-else v-model="data.DpNo" placeholder="请输入部门编码"></el-input> -->
        </el-form-item>
        <el-form-item label="分类编码" prop="ClassNo">
          <el-input v-model="data.ClassNo" placeholder="请输入分类编码" />
          <!-- <span v-if="Mode==0" class="detail-span">{{data.ClassNo}}</span>
          <el-input v-else v-model="data.ClassNo" placeholder="请输入分类编码"></el-input> -->
        </el-form-item>
        <el-form-item label="分类名称" prop="ClassName">
          <el-input v-model="data.ClassName" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item label="分类序号">
          <el-input
            type="number"
            v-int
            v-model="data.Sn"
            style="width: 100px"
          ></el-input>
          <!-- <el-input-number v-model="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <template #footer>
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        Pid: null,
        PclassName: "",
        ClassId: 0,
        ClassType: 1,
        ClassNo: "",
        ClassName: "",
        Status: 1,
        Sn: null,
      },
      Mode: 1,
      code_api: require("@/api/sy/serialCode").default,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/class").default,
      // trendData: iForm.Data,
      showList: [],
      rules: {
        ClassNo: [{ required: true, message: "请输入分类编码" }],
        ClassName: [{ required: true, message: "请输入分类名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
      classList: [],
      mel:false,
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      console.log(this.data)
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
  
    },
    changePid(val){
      let item = this.classList.filter(item => {
        return item.ClassId === val
      })[0];

      this.data.Pid = item.ClassId;
      this.data.PclassName = item.ClassName;

      if(this.data.ClassId==0){
         this.getMaxSn()
      }

    },
    getMaxSn(){
      this.api.getMaxSn(1,this.data.Pid||0).then((res)=>{
        this.data.Sn = res;
      });
    },
    onCreateOpened(data) {
      this.getMaxSn()
      // this.api.getMaxSn().then((res) => {
      //   this.data.Sn = res;
      // });

      this.api.list({ClassType: 1}).then((res) => {
        if(res.Code === 0){
          this.classList = res.Data;
        }
      });
      
      // this.code_api.previewNo("产品类别").then((res) => {
      //   console.log("serialType", res);
      //   if (res.Code == 0) {
      //     this.Mode = res.Data.Mode;
      //     this.data.ClassNo = res.Data.PreviewNo;
      //   } else {
      //     this.$message.warning("获取产品类别编号失败");
      //   }
      // });
    },
    onEditOpened(data) {
      this.api.list({ClassType: 1}).then((res) => {
        if(res.Code === 0){
          this.classList = res.Data;
        }
      });
    },
    toSave() {
      this.$refs.dialog.formValidate().then((valid) => {
        if (!valid) return;
        //移除 null 与 "" 的值
        var data = this.$commonJs.obj.removeNullKey(this.data);
        this.$refs.dialog.isLoading = true;
        this.api.save(data).then((res) => {
          this.$refs.dialog.isLoading = false;
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            this.$emit("close-saved");
            this.close(true);
          } else {
            this.$message.error(res.Msg);
          }
        });
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
